import { render, staticRenderFns } from "./FormsView.vue?vue&type=template&id=b4c9dd1e&scoped=true&"
import script from "./FormsView.vue?vue&type=script&lang=js&"
export * from "./FormsView.vue?vue&type=script&lang=js&"
import style0 from "./FormsView.vue?vue&type=style&index=0&id=b4c9dd1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c9dd1e",
  null
  
)

export default component.exports